<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.042499, 0, 0, -0.042522, -0.565021, 499.996765)">
    <path
      d="M6840 11748 c-86 -12 -226 -59 -319 -108 -252 -132 -466 -388 -570 -683 -118 -335 -103 -760 44 -1214 128 -398 302 -705 540 -951 154 -160 322 -269 505 -327 104 -34 300 -45 414 -25 572 101 1094 823 1248 1726 16 100 22 172 22 319 1 204 -9 274 -60 438 -139 438 -506 769 -918 826 -94 13 -813 13 -906 -1z"
    />
    <path
      d="M6035 8159 c-289 -95 -544 -241 -724 -414 l-94 -91 90 -37 c314 -130 611 -398 793 -716 97 -171 169 -362 211 -567 29 -141 37 -477 16 -664 -42 -361 -142 -713 -293 -1029 -35 -74 -64 -136 -64 -138 0 -2 759 -2 1688 -1 l1687 3 70 23 c110 37 169 76 290 194 153 148 205 249 205 400 0 90 -259 1928 -282 1998 -27 84 -103 246 -158 335 -154 252 -392 467 -654 591 -74 35 -440 164 -466 164 -3 0 -183 -189 -400 -420 l-395 -420 -5 219 -5 219 -30 44 c-57 80 -134 114 -240 105 -71 -5 -132 -33 -170 -79 -52 -61 -55 -81 -55 -313 l0 -215 238 0 237 0 -5 -838 -5 -839 -30 -49 c-19 -30 -49 -60 -79 -79 -44 -27 -58 -30 -131 -30 -73 0 -87 3 -131 30 -30 19 -60 49 -79 79 l-30 49 -5 833 -5 833 -410 435 c-225 240 -414 436 -420 435 -5 0 -77 -23 -160 -50z"
    />
    <path
      d="M3980 7211 c-468 -102 -834 -540 -899 -1076 -62 -510 151 -1216 514 -1700 195 -260 438 -440 682 -507 112 -30 334 -30 446 0 432 118 815 559 1049 1207 126 350 184 763 144 1033 -42 285 -159 530 -344 724 -102 107 -186 169 -317 233 -199 99 -199 99 -730 102 -416 2 -468 0 -545 -16z"
    />
    <path
      d="M10390 4981 c0 -101 -99 -356 -191 -492 -122 -181 -324 -333 -549 -414 -178 -63 -49 -58 -1830 -64 l-1625 -6 111 -57 c164 -86 283 -169 401 -282 290 -276 448 -523 578 -906 52 -152 60 -185 96 -430 21 -146 39 -268 39 -273 0 -4 309 -6 688 -5 l687 3 55 23 c45 18 304 239 1470 1250 l1415 1227 23 65 c42 116 17 254 -59 328 -63 61 -70 62 -721 62 l-588 0 0 -29z"
    />
    <path
      d="M1431 3661 c-1525 -1314 -1416 -1210 -1416 -1356 0 -111 32 -165 120 -206 38 -18 79 -19 730 -19 l691 0 63 293 c35 160 81 344 103 407 47 140 156 363 236 485 270 413 697 731 1133 845 l87 22 -73 112 c-82 125 -191 330 -256 484 -24 56 -48 102 -54 101 -5 0 -619 -526 -1364 -1168z"
    />
    <path
      d="M3180 3624 c-417 -140 -726 -406 -920 -794 -105 -209 -98 -174 -241 -1225 -71 -522 -129 -980 -129 -1017 0 -154 52 -278 168 -399 59 -63 92 -88 156 -120 150 -73 -9 -69 2274 -69 2277 0 2116 -5 2270 66 264 121 401 307 402 544 0 35 -59 487 -130 1005 -145 1050 -139 1017 -251 1236 -61 118 -165 266 -252 358 -154 164 -433 338 -673 420 l-91 31 -1239 0 -1239 0 -105 -36z"
    />
  </g>
</template>
